import React from 'react'

import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"

// const debug = "SelectParent_AllProjects"
const debug = false

export default function SelectParent_AllProjects() {
    return (
        <div className="flex-column-right-top w-100-percent h-100-percent">
            <VScroll className="h-100-percent p-b-10">
                <div className="flex-column-center-center h-100-percent">
                    <div className="isvg-all-projects w-130 min-h-76"/>
                    <div className="ui5-txt-no-accent-small p-t-20">All projects across all workspaces</div>
                </div>
            </VScroll>
        </div>
    )
}
